module.exports = __webpack_public_path__ + "img/9791158882433.69309ddc.jpg";